var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.335,
    height: 73.335,
    viewBox: "0 0 73.335 73.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1488",
    d: "M0-682.665H73.335v73.335H0Z",
    transform: "translate(0 682.665)",
    fill: "#7b7bff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report_1321938",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1482",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1484",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1486",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1492",
    transform: "translate(34.376 22.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1494",
    d: "M-11.9,0a1.433,1.433,0,0,1,1.432,1.432A1.433,1.433,0,0,1-11.9,2.865a1.433,1.433,0,0,1-1.432-1.432A1.433,1.433,0,0,1-11.9,0",
    transform: "translate(13.333 0)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1496",
    transform: "translate(34.376 28.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1498",
    d: "M-11.9,0a1.433,1.433,0,0,1,1.432,1.432A1.433,1.433,0,0,1-11.9,2.865a1.433,1.433,0,0,1-1.432-1.432A1.433,1.433,0,0,1-11.9,0",
    transform: "translate(13.333 0)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1500",
    transform: "translate(57.579 1.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1502",
    d: "M-119.01-119.01h-14.323v-14.323",
    transform: "translate(133.333 133.333)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1504",
    transform: "translate(36.667 10.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1506",
    d: "M0,0H15.183",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1508",
    transform: "translate(36.667 15.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1510",
    d: "M0,0H15.183",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1512",
    transform: "translate(1.432 10.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1514",
    d: "M-238.02-119.01a14.328,14.328,0,0,1-11.459,14.037,14.4,14.4,0,0,1-2.865.286,14.323,14.323,0,0,1-14.323-14.323,14.323,14.323,0,0,1,14.323-14.323,14.4,14.4,0,0,1,2.865.286A14.328,14.328,0,0,1-238.02-119.01Z",
    transform: "translate(266.666 133.333)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1516",
    transform: "translate(7.162 24.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1518",
    d: "M-71.406-71.406A8.6,8.6,0,0,1-80-80",
    transform: "translate(80 80)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1520",
    transform: "translate(15.756 10.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1522",
    d: "M0,0V14.323H14.323",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1524",
    transform: "translate(18.62 1.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1526",
    d: "M0-307.045v30.652a2.864,2.864,0,0,0,2.865,2.865H50.418a2.864,2.864,0,0,0,2.865-2.865v-53.282L38.959-344H2.865A2.864,2.864,0,0,0,0-341.134v6.016",
    transform: "translate(0 343.999)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1528",
    transform: "translate(24.349 56.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1530",
    d: "M-47.6-23.8a2.864,2.864,0,0,1-2.865,2.865A2.864,2.864,0,0,1-53.333-23.8a2.864,2.864,0,0,1,2.865-2.865,2.856,2.856,0,0,1,2.025.839A2.856,2.856,0,0,1-47.6-23.8Z",
    transform: "translate(53.333 26.667)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1532",
    transform: "translate(35.235 45.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1534",
    d: "M-6.974-40.63a2.856,2.856,0,0,1-.839-2.025A2.864,2.864,0,0,1-4.949-45.52a2.864,2.864,0,0,1,2.865,2.865,2.856,2.856,0,0,1-.839,2.025,2.856,2.856,0,0,1-2.025.839A2.856,2.856,0,0,1-6.974-40.63Z",
    transform: "translate(7.813 45.52)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1536",
    transform: "translate(45.261 56.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1538",
    d: "M-47.6-23.8a2.864,2.864,0,0,1-2.865,2.865A2.864,2.864,0,0,1-53.333-23.8a2.856,2.856,0,0,1,.839-2.025,2.856,2.856,0,0,1,2.025-.839A2.864,2.864,0,0,1-47.6-23.8Z",
    transform: "translate(53.333 26.667)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1540",
    transform: "translate(60.014 39.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1542",
    d: "M-47.6-23.8a2.864,2.864,0,0,1-2.865,2.865A2.864,2.864,0,0,1-53.333-23.8a2.864,2.864,0,0,1,2.865-2.865A2.864,2.864,0,0,1-47.6-23.8Z",
    transform: "translate(53.333 26.667)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1544",
    transform: "translate(29.239 50.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1546",
    d: "M0-61.552,6.835-68.96",
    transform: "translate(0 68.96)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1548",
    transform: "translate(40.125 50.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1550",
    d: "M0,0,5.976,7.408",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1552",
    transform: "translate(49.716 44.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1554",
    d: "M0-103.205l11.573-12.421",
    transform: "translate(0 115.626)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1556",
    transform: "translate(41.537 24.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1558",
    d: "M0,0H21.771",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1560",
    transform: "translate(41.537 30.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1562",
    d: "M0,0H21.771",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArA);
export default __webpack_public_path__ + "static/media/AR_A.4a32f9c882876b6205641bb3fb9f523d.svg";
export { ForwardRef as ReactComponent };